import { render, staticRenderFns } from "./UserReportForm.vue?vue&type=template&id=684e5417&scoped=true&"
import script from "./UserReportForm.vue?vue&type=script&lang=js&"
export * from "./UserReportForm.vue?vue&type=script&lang=js&"
import style0 from "./UserReportForm.vue?vue&type=style&index=0&id=684e5417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e5417",
  null
  
)

export default component.exports